export const CREATE_PRODUCT_KEY = 'CREATE_PRODUCT_KEY';
export const UPDATE_PRODUCT_KEY = 'UPDATE_PRODUCT_KEY';
export const UPDATE_PRODUCT_AT_ADMIN_KEY = 'UPDATE_PRODUCT_AT_ADMIN_KEY';
export const DELETE_PRODUCT_KEY = 'DELETE_PRODUCT_KEY';
export const FETCH_PRODUCT_LIST_KEY = 'FETCH_PRODUCT_LIST_KEY';
export const FETCH_PRODUCT_BY_ID_KEY = 'FETCH_PRODUCT_BY_ID_KEY';
export const FETCH_PRODUCT_BY_PROJECT_ID_KEY = 'FETCH_PRODUCT_BY_PROJECT_ID_KEY';
export const ORDER_CATALOGS_KEY = 'ORDER_CATALOGS_KEY';
